import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  DATA_TABLE_VIEW_ID_HOUSEHOLD_DASHBOARD_ALL,
} from 'common/dataTableConstants';

import SrDarkModal from 'client/components/SrDarkModal';
import SrDataTableHouseholdDashboard from 'client/components/SrDataTableHouseholdDashboard';

class SrRenterHouseholdsModal extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    householdAdminsList: PropTypes.array.isRequired,
    renter: PropTypes.object.isRequired,
    reloadDataTableHousehold: PropTypes.func.isRequired,
  }

  render() {
    const {
      onClose,
      householdAdminsList,
      renter,
      reloadDataTableHousehold,
    } = this.props;

    return (
      <SrDarkModal onClose={onClose}>
        <div
          onClick={(event) => event.stopPropagation()}
          className='adminDefaultModal SrRenterHouseholdsModal'
        >
          <div className='householdsContainer'>
            <SrDataTableHouseholdDashboard
              viewId={DATA_TABLE_VIEW_ID_HOUSEHOLD_DASHBOARD_ALL}
              userId={renter.id}
              householdAdminsList={householdAdminsList}
              reloadDataTableHousehold={reloadDataTableHousehold}
            />
          </div>
        </div>
      </SrDarkModal>
    );
  }
}

export default SrRenterHouseholdsModal;
